import React, { useEffect } from 'react';
import Head from 'next/head';
import useAuth from '../src/auth/use-auth';
import { useRouter } from 'next/router';
import { RoutesEnum } from '../src/types/routes.enum';

export default function Page() {
    const { isAuthenticated } = useAuth();
    const router = useRouter();

    useEffect(() => {
        if (isAuthenticated) {
            router.push(RoutesEnum.DASHBOARD);
        } else {
            router.push(RoutesEnum.LOGIN);
        }
    }, [isAuthenticated, router]);

    return (
        <>
            <Head>
                <title>Member portal</title>
            </Head>
            <main>
                <></>
            </main>
        </>
    );
}
